<template>
  <v-dialog v-model="show" width="464" content-class="popup-wrap-1">
    <div class="pa-9">
      <v-form ref="form">
        <div class="search-1">
          <div class="input relative flex-grow-1">
            <v-text-field
              label="CC 코스 명"
              class="input-custom-1"
              height="40px"
              solo
              v-model="searchText"
              @input="searchCourses"
              @keypress.enter.prevent="searchCourses"
            ></v-text-field>
            <v-btn icon class="btn">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </div>
        </div>

        <p class="title-type-4">검색 결과</p>

        <div class="white rounded" style="height: 200px; border: 1px solid red">
          <vue-scroll class="list-wrap">
            <v-radio-group
              v-model="radioColumn"
              column
              class="mt-0 pt-6 pl-6"
              :rules="rules"
            >
              <v-radio
                v-for="item in searchList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                @click="selectedCourse = item"
                color="#fecd00"
                class="radio-type-1 list-row"
              ></v-radio>
            </v-radio-group>
            <div class="no-matching-custom" v-if="!searchList.length">
              No matching data.
            </div>
          </vue-scroll>
        </div>
      </v-form>

      <div class="d-flex justify-end mt-6">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fff"
          class="button-type-2"
          @click.stop="clear"
        >
          취소
        </v-btn>
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1 ml-2"
          @click.prevent="update"
        >
          저장
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    propCourse: Object,
    courseList: Array,
  },
  data: () => ({
    radioColumn: null,
    searchText: null,
    searchList: [],
    selectedCourse: null,
    rules: [v => !!v],
  }),
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    update() {
      const validate = this.$refs.form.validate();
      if (!validate) return;

      this.show = false;

      this.$emit('select:course', this.selectedCourse);
    },
    clear() {
      this.show = false;

      this.searchText = null;
      this.selectedCourse = this.propCourse;
      this.radioColumn = this.propCourse ? this.propCourse.id : null;
      this.searchCourses();
    },
    searchCourses() {
      if (!this.searchText) {
        this.searchList = this.courseList;
        return;
      }

      const filter = this.searchText.toUpperCase();
      this.searchList = this.courseList.filter(
        course => course.name.toUpperCase().indexOf(filter) > -1,
      );
    },
  },
  watch: {
    propCourse: {
      deep: true,
      handler() {
        if (!this.propCourse) return;

        this.selectedCourse = this.propCourse;
        this.radioColumn = this.selectedCourse.id;
      },
    },
    courseList: {
      deep: true,
      immediate: true,
      handler() {
        this.searchCourses();
      },
    },
  },
  async created() {
    this.selectedCourse = this.propCourse;
    this.radioColumn = this.propCourse ? this.propCourse.id : null;
  },
};
</script>

<style scope>
.no-matching-custom {
  text-align: center;
  margin-top: -20px;
  font-size: 14px;
}
</style>
